var Products = $.extend(false, BaseModule ,{
    api_route       : 'catalogue/products',
    original_data   : {},
	data : {
        module          : 'products',
        limit           : 20, 
        with            : '',
        with_main_image : 1,
        details_with    : 'categories:descriptions:prices:user_uploaded:notifications:attributes:media.details',
        view            : 'list',
        action          : '',
        pagination      : 1,
        order_by        : 'id:desc' 
    },
   
    save_order:function(){
        var module_name = this.data.module;
        var module = this;

        var selection = [];
        $('input[name="order_item_id[]"]').each(function(){ 
            selection.push($(this).val());
        });

        $.ajax({
            url : API + module.api_route + '/order',
            method:'POST',
            data:{ 
                category_id     : $('#'+module_name+'-dialog-list  select[name="category_id"]').val(),
                manufacturer_id : $('#'+module_name+'-dialog-list  select[name="manufacturer_id"]').val(),
                order_item_id   : selection 
            },
            success:function(data){
                $("#"+module_name+"-dialog-list").modal('hide');
            }
        });
        return false;
    },
     before_save:function(){
          $('#products_form .editor').each(function(){
             var content_id = $(this).attr('id');      
            
            /*
            if(typeof( CKEDITOR.instances[content_id])!=='undefined' ){
                var content = CKEDITOR.instances[content_id].getData();
                $(this).val(content);
            }
            */

         });
        
    },

	edit_selected:function(id){
        var module_name = this.data.module;
        var module = this;
        $('#'+module_name+'-edit-selected-dialog input[name="id"]').val(id);
        $('#'+module_name+'-edit-selected-dialog')
            .data({'id':id})
            .modal({
                backdrop:false,
                show:true
            });
        initForm('#'+module_name+'-edit-selected-dialog');
        module.after_load_entry();
    },

   add_note:function(id){
        var content_id = $('[name="review_note"]').attr('id');
      
        var content =  tinyMCE.get(content_id).getContent();


        var module_name = this.data.module;
        var module = this;
        $.ajax({
            url : API + module.api_route + '/review',
            method:'POST',
            data:{'id':id,'review':content},
            success:function(data){
                $("#"+module_name+"-dialog-list").modal('hide');
            }
        });
   },
    
    
    set_new_flag:function(id){
        var module_name = this.data.module;
        var module = this;
        $('#'+module_name+'-set-new-dialog input[name="id"]').val(id);
        $('#'+module_name+'-set-new-dialog')
            .data({'id':id})
            .modal({
                backdrop:false,
                show:true
            });
        initForm('#'+module_name+'-set-new-dialog');
    },

    add_block : function (){
        var html_template = $('.block-select-template').html();
        var markup = $('<div style="clear:both;" class="list-group-item blockRow">'+html_template+'</div>');
        $('.blocks-list').append(markup).fadeIn('slow');
        if($('.blocks-list .blockRow').length == 1){
            $('.remove-block-trigger').hide();
        }else{
            $('.remove-block-trigger').show();
        }
        initForm('.blocks-list:not(:hidden) .blockRow:last');

    },

    execute_import:function(f){
		var module_name = this.data.module;
		var module = this;
		$.ajax({data:$('form[name="'+module_name+'_form"]').serialize(),success:function(data){
			if(data.status == 'ok'){
				module.load_list();
			}else{
				show_message('nFailure',data.error);
			}
		}});
	},

    add_attribute:function(container,attributes_group){

        var b = $('body');

        if($("#create-attribute-dialog").length === 0){

            b.append('<div id="create-attribute-dialog" class="modal fade modal-fade-in-scale-up show" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">\
                        <div class="modal-dialog">\
                            <div class="modal-content">\
                                <div class="modal-header">\
                                    <h4 class="modal-title " style="float:left">Create Attribute</h4>\
                                    <button type="button"  style="float:right" class="close" data-dismiss="modal" aria-hidden="true">×</button>\
                                </div>\
                                <div class="modal-body">\
                                <label style="display:block;position:relative;">Attribute Type<br><div><select name="code" class="form-control" style="display:block;width: 460px;" data-plg="select2" data-ajax="catalogue/products/attributes" data-request-data=\'{"type":"'+ attributes_group +'"}\' data-search="code"  data-value="code"></select></div></label><br>\
                                </div>\
                                <div class="modal-footer">\
                                    <button type="button" class="btn btn-default btn-sm" data-dismiss="modal">Close</button>\
                                    <button type="button" class="btn btn-primary btn-sm btn-ok">Create Attribute</button>\
                                </div>\
                                </div>\
                            </div>\
                        </div>\
                    </div>');
        }

        $("#create-attribute-dialog").on('shown.bs.modal', function () {
            $("#create-attribute-dialog .btn-ok").on('click',function(){
                var markup = '';

                var code = $("#create-attribute-dialog select[name=\"code\"]").val();
                var v = $("#create-attribute-dialog input[name=\"value\"]").val();

                if(attributes_group == 'prices'){
                    markup = '  <div class="col-xs-12 col-sm-6 col-md-6"><div class="form-group row">\
                                    <label class="col-md-3 col-lg-2 form-control-label">'+code+'</label>\
                                    <div class="col-md-9 col-lg-10">\
                                        <input type="text" required="" class="form-control required " name="data[prices]['+code+'][value]" value="">\
                                        <input type="hidden" required="" class="form-control required " name="data[prices]['+code+'][currency]" value="EURO">\
                                    </div>\
                                </div></div>';

                }else if(attributes_group == 'attributes'){
                     $.ajax({
                        url : API + 'catalogue/products/selected_attribute',
                        data:{
                            attribute : code
                        },
                        method:'GET',
                        dataType:'html',
                        success:function(data){
                            d = JSON.parse(data);
                            if(d.success){
                                $(container).append(d.markup);
                                initForm(container);
                            }
                            
                        }
                    });
               
                }else{
                    markup = '<div class="form-group row">\
                                    <label class="col-md-3 col-lg-2 form-control-label">'+code+'</label>\
                                    <div class="col-md-9 col-lg-10">\
                                        <textarea class="form-control" name="data['+attributes_group+']['+code+'][value]"></textarea>\
                                    </div>\
                                </div>';
                }
                $(container).append(markup);

                $("#create-attribute-dialog").modal('hide');

            });
            initForm('#create-attribute-dialog');

        }).on('hidden.bs.modal', function () {
            $("#create-attribute-dialog").remove();

        }).modal('show');

    },

    import_form:function(data){
        var module_name = this.data.module,
            module = this;
            
        $("#import-dialog").on('shown.bs.modal', function () {

            $("#import-dialog .btn-ok").on('click',function(){
                var $files = [] , 
                    $types = [];

                $('#import-dialog input[name="filename[]"]').each(function(){
                    var v = $(this).val();
                    $files.push(v);
                });

                $('#import-dialog select[name="import_type[]"]').each(function(){
                    var v = $(this).find('option:selected').val();
                    $types.push(v);
                });

                console.log($files);
                $.ajax({
                    url : API + 'catalogue/products/import',
                    data:{
                        files : $files,
                        types : $types
                    },
                    type:'PUT',
                    error:function(){
                        GlobalModule.show_message('danger','Something went wrong');
                    },
                    success:function(data){

						GlobalModule.show_message('success','Successfuly submited. Import information is not available');

                    }
                });
                $("#import-dialog").modal('hide');

            });
            initForm('#import-dialog');

        }).on('hidden.bs.modal', function () {
            
            module.load_list();

        }).modal('show');

    },
	make_feature:function(id,way){
		var module_name = this.data.module;
		var module = this;
		$.ajax({data:{module:module_name,action:'featured',id:id,way:way},success:function(data){
			if(data.status == 'ok'){
				module.load_list();
			}else{
				show_message('nFailure',data.error);
			}
		}});
	},

   

    init:function(){
        "use strict";
        var module_name = this.data.module,
            module = this;
    }

});

$(document).ready(function(){
    "use strict";
	Products.init();
});
